import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1>Contactez-Nous</h1>
        <p>Nous sommes là pour répondre à toutes vos questions</p>
      </section>
      <section className="contact-content">
        <div className="contact-message">
          <h2>Prenez contact avec nous</h2>
          <p>
            Si vous avez des questions, des suggestions ou besoin d'assistance, n'hésitez pas à nous contacter. Vous pouvez nous joindre directement à l'adresse suivante :{' '}
            <a href="mailto:dwag.contact@gmail.com">dwag.contact@gmail.com</a>.
          </p>
          <p>
            Notre équipe s'efforce de répondre à toutes les demandes dans les plus brefs délais, généralement sous 24 à 48 heures. Merci de faire partie de la communauté DWAG !
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;